/**
 * Controle des identifiants SIREN et SIRET (cle de Luhn).
 *
 * Regle de l'INSEE (paquet InseeFrLab/validinsee) : un SIRET est valide si sa
 * somme de Luhn et celle de son SIREN sont des multiples de 10. Exception : La
 * Poste (SIREN 356000000) a plus d'etablissements que de NIC disponibles ; un
 * de ses SIRET qui echoue au controle de Luhn est valide si la somme simple de
 * ses 14 chiffres est un multiple de 5.
 */

export const SIREN_LA_POSTE = '356000000';

/** Somme de Luhn : un chiffre sur deux double en partant de la droite, cle comprise. */
function sommeLuhn(chiffres: string): number {
  let somme = 0;
  for (let rang = 0; rang < chiffres.length; rang += 1) {
    let chiffre = Number(chiffres[chiffres.length - 1 - rang]);
    if (rang % 2 === 1) {
      chiffre *= 2;
      if (chiffre > 9) chiffre -= 9;
    }
    somme += chiffre;
  }
  return somme;
}

export function sirenValide(siren: string): boolean {
  return /^\d{9}$/.test(siren) && sommeLuhn(siren) % 10 === 0;
}

export function siretValide(siret: string): boolean {
  if (!/^\d{14}$/.test(siret)) return false;
  const siren = siret.slice(0, 9);
  if (sirenValide(siren) && sommeLuhn(siret) % 10 === 0) return true;
  if (siren !== SIREN_LA_POSTE) return false;
  const somme = [...siret].reduce((total, chiffre) => total + Number(chiffre), 0);
  return somme % 5 === 0;
}
